import {
    CONTACT_INFO__MUTATE_FIRST_NAME,
    CONTACT_INFO__MUTATE_LAST_NAME,
    CONTACT_INFO__MUTATE_PHONE,
    CONTACT_INFO__MUTATE_EMAIL,
    CONTACT_INFO__MUTATE_VALID,
    CONTACT_INFO__UPDATE_FIRST_NAME,
    CONTACT_INFO__UPDATE_LAST_NAME,
    CONTACT_INFO__UPDATE_PHONE,
    CONTACT_INFO__UPDATE_EMAIL,
    CONTACT_INFO__UPDATE_VALIDATION,
    ORDER__UPDATE_NAME,
    ORDER__UPDATE_PHONE,
    ORDER__UPDATE_EMAIL,
} from '../types';

const createInitialState = () => ({
    fname: '',
    lname: '',
    email: '',
    phone: '',
    valid: false,
});

export const mutations = {
    [CONTACT_INFO__MUTATE_FIRST_NAME](state, payload) {
        state.fname = payload.fname;
    },
    [CONTACT_INFO__MUTATE_LAST_NAME](state, payload) {
        state.lname = payload.lname;
    },
    [CONTACT_INFO__MUTATE_PHONE](state, payload) {
        state.phone = payload.phone;
    },
    [CONTACT_INFO__MUTATE_EMAIL](state, payload) {
        state.email = payload.email;
    },
    [CONTACT_INFO__MUTATE_VALID](state, payload) {
        state.valid = payload.valid;
    },
};

export const actions = {
    [CONTACT_INFO__UPDATE_FIRST_NAME]({ commit, dispatch }, payload) {
        commit(CONTACT_INFO__MUTATE_FIRST_NAME, payload);
        dispatch(ORDER__UPDATE_NAME, payload);
    },
    [CONTACT_INFO__UPDATE_LAST_NAME]({ commit, dispatch }, payload) {
        commit(CONTACT_INFO__MUTATE_LAST_NAME, payload);
        dispatch(ORDER__UPDATE_NAME, payload);
    },
    [CONTACT_INFO__UPDATE_PHONE]({ commit, dispatch }, payload) {
        commit(CONTACT_INFO__MUTATE_PHONE, payload);
        dispatch(ORDER__UPDATE_PHONE, payload);
    },
    [CONTACT_INFO__UPDATE_EMAIL]({ commit, dispatch }, payload) {
        commit(CONTACT_INFO__MUTATE_EMAIL, payload);
        dispatch(ORDER__UPDATE_EMAIL, payload);
    },
    [CONTACT_INFO__UPDATE_VALIDATION]({ commit }, payload) {
        commit(CONTACT_INFO__MUTATE_VALID, payload);
    },
};

export const contactInfo = {
    state: createInitialState,
    mutations,
    actions,
};
